package fr.manyverse.app.infrastructure.shake

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

actual class ShakeDetector {
    actual fun start(onShake: () -> Unit) = Unit
    actual fun stop() = Unit
}

@Composable
actual fun rememberShakeDetector(onShake: () -> Unit): ShakeDetector = remember { ShakeDetector() }
